import React from 'react';
import { Text } from '@components-library/Typography';
import { IHeaderTextContext } from '@components-shared/table/types';
import { getUtcOffsetDescription } from '@utils/library/dateTime';

export const getHeaderTextWithUtcOffset = (context: IHeaderTextContext, headerText?: string): JSX.Element => {
  const { utcOffsetInHours } = context;

  return (
    <>
      {headerText && <Text>{headerText}</Text>} <span> [{getUtcOffsetDescription(utcOffsetInHours)}]</span>
    </>
  );
};

interface IColumnWithHeader {
  name?: string;
  getHeaderText?: (context: IHeaderTextContext, header?: string) => JSX.Element;
}

export const getColumnHeaderText = (context: IHeaderTextContext, column: IColumnWithHeader): JSX.Element => {
  const headerName = column.name ? column.name : '';

  if (column.getHeaderText) {
    return column.getHeaderText(context, headerName);
  }

  return <Text>{headerName}</Text>;
};
